import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useInsertData } from "../../hooks/useInsertData";
import { useGetData } from "../../hooks/useGetData";
import { useUpdateData } from "../../hooks/useUpdateDate";
import useDeleteData from "../../hooks/useDeleteData";

export const createMaintenanceType = createAsyncThunk("maintenanceType/createMaintenanceType", async (data, { rejectWithValue }) => {
  try {
    const res = await useInsertData("maintenanceTypes", data);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const getAllMaintenanceTypes = createAsyncThunk("maintenanceType/getAllMaintenanceTypes", async (_, { rejectWithValue }) => {
  try {
    const res = await useGetData("maintenanceTypes");
    return res;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const getMaintenanceTypesById = createAsyncThunk("maintenanceType/getMaintenanceTypesById", async (id, { rejectWithValue }) => {
  try {
    const res = await useGetData(`maintenanceTypes/${id}`);
    return res;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const updateMaintenanceType = createAsyncThunk("maintenanceType/updateMaintenanceType", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await useUpdateData(`maintenanceTypes/${id}`, data);
    return res;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const deleteMaintenanceType = createAsyncThunk("maintenanceType/deleteMaintenanceType", async (id, { rejectWithValue }) => {
  try {
    const res = await useDeleteData(`maintenanceTypes/${id}`);
    return res;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});

const initialState = {
  maintenanceType: null,
  allMaintenanceType: null,
  specificMaintenanceType: null,
  status: "idle",
  error: null,
};
export const maintenanceTypeSlice = createSlice({
  name: "MaintenanceType",
  initialState,
  reducers: {
    resetState: (state) => {
      return { ...state, status: "idle", error: null };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createMaintenanceType.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createMaintenanceType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.maintenanceType = action.payload;
      })
      .addCase(createMaintenanceType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getAllMaintenanceTypes.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllMaintenanceTypes.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allMaintenanceType = action.payload;
      })
      .addCase(getAllMaintenanceTypes.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getMaintenanceTypesById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getMaintenanceTypesById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.specificMaintenanceType = action.payload;
      })
      .addCase(getMaintenanceTypesById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });

    // //---------------------------------------
    // .addCase(resendCode.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(resendCode.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.resendCodeResponse = action.payload;
    // })
    // .addCase(resendCode.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(loginUser.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(loginUser.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.currentUser = action.payload.data;
    //   state.token = action.payload.token;
    // })
    // .addCase(loginUser.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(getCurrentUser.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(getCurrentUser.fulfilled, (state, action) => {
    //   state.currentUser = action.payload.user;
    //   state.status = "succeeded";
    // })
    // .addCase(getCurrentUser.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(forgetPassword.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(forgetPassword.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.forgetPasswordResponse = action.payload;
    // })
    // .addCase(forgetPassword.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(resetPassword.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(resetPassword.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.resetPasswordResponse = action.payload;
    // })
    // .addCase(resetPassword.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(updateUserData.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(updateUserData.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.user = action.payload;
    // })
    // .addCase(updateUserData.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // });
  },
});
export const { resetState } = maintenanceTypeSlice.actions;
export default maintenanceTypeSlice.reducer;
